import SubsidiesSplittingAll from './SubsidiesSplittingAll'


export default SubsidiesSplittingAll
